"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_TOO_MANY_ERROR = exports.ADD_TOO_MANY_ERROR = function ADD_TOO_MANY_ERROR(wantedQuantity, allowedQuantity, name) {
  return "Unfortunately there isn't " + wantedQuantity + " " + name + "'s left. We've added " + allowedQuantity + " to the cart instead.";
};
var ALREADY_HAVE_ALL_STOCK_ERROR = exports.ALREADY_HAVE_ALL_STOCK_ERROR = function ALREADY_HAVE_ALL_STOCK_ERROR(name) {
  return "You already have all of the \"" + name + "\" in your cart";
};
var NOT_ENOUGH_IN_STOCK_ERROR = exports.NOT_ENOUGH_IN_STOCK_ERROR = function NOT_ENOUGH_IN_STOCK_ERROR(name) {
  return "Unfortunately, there isn't that many of \"" + name + "\" left in stock";
};
var UNKNOWN_ERROR = exports.UNKNOWN_ERROR = function UNKNOWN_ERROR() {
  return "There was an error adding these items to the cart";
};